var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"repeat-box"},[_c('van-nav-bar',{attrs:{"left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('img',{staticClass:"repeat-img",attrs:{"src":require("../assets/img/defaultpage_img_null@2x.png"),"alt":""}}),_c('p',{staticClass:"repeat-desc"},[_vm._v(_vm._s(decodeURI(_vm.msg)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }